import { send } from "../../send";

/**
 * send(1.method, 2.url, 3.data, 4.expend) 1.请求类型 2.请求地址 3.请求参数 4.拓展(如统一的uuid)
 * 事件中心 巡检模块
 */

export const Event = {
    // 查询事件列表
    getEventList(parmas, expend) {
        return send("GET", "/api/company/siteDeviceEvent/find", parmas, expend);
    },
    // 添加事件
    postAddEvent(parmas, expend) {
        return send("POST", "/api/company/siteDeviceEvent/create", parmas, expend);
    },
    // 修改事件
    postEditEvent(parmas, expend) {
        return send("POST", "/api/company/siteDeviceEvent/update", parmas, expend);
    },
    // 修改事件截止天数
    postEditEventDays(parmas, expend) {
        return send("POST", "/api/company/siteDeviceEvent/update/expireDate", parmas, expend);
    },
    // 修改事件开始日期(上报事件接口)
    postEditEventDate(parmas, expend) {
        return send("POST", "/api/company/siteDeviceEvent/update/startDate", parmas, expend);
    },
    // 删除事件
    postDelEvent(parmas, expend) {
        return send("POST", "/api/company/siteDeviceEvent/delete", parmas, expend);
    },
    // 事件详情
    getDeiltData(parmas, expend) {
        return send("GET", "/api/company/siteDeviceEvent/get", parmas, expend);
    },
    /**
     * 巡检模块
     */
    getInspectionList(parmas, expend) { // 巡检考勤
        return send("GET", "/api/company/inspection/find", parmas, expend);
    },
    getInspectionDetails(parmas, expend) { // 巡检详情
        return send("GET", "/api/company/inspection/get", parmas, expend);
    },

    getWorkList(parmas, expend) { // 工单
        return send("GET", "/api/company/inspectionWorksheet/find", parmas, expend);
    },
    // 巡检新接口
    submitIspect(parmas, expend) {
        return send("GET", "/api/company/inspection/feedback", parmas, expend);
    },
    replyWorkApi(parmas, expend) {
        return send("POST", "/api/company/inspectionWorksheet/reply", parmas, expend);
    },
    completeWorkApi(parmas, expend) {
        return send("POST", "/api/company/inspectionWorksheet/completed/" + parmas.id, parmas, expend);
    }
}